<div class="ltms-feed-detail-panel" [class.show]="this._feedService.isFeedDetailsVisible()" [id]="'feed-details_'+feedId">
  <div class="blank-space" (click)="closeFeedDetailPanel()"></div>
  <div class="ltms-feed-detail-container" [class.fullscreen]="fullscreen">
    <div class="ltms-feed-detail-header">
      <div class="left-panel">
        <div class="ltms-feed-detail-tabs">
          <div class="ltms-feed-detail-tab" *ngFor="let tab of tabs" [class.active]="activeTab.key == tab.key" (click)="onChangeTab(tab)">
            {{tab.name}}
            <span *ngIf="tab.tab_type" class="ltms-feed-detail-tab-chip">
              {{tab.tab_type}}
            </span>
          </div>
        </div>
      </div>
      <div class="right-panel">
        <div class="ltms-button-group">
          <button (click)="previousFeed()" *ngIf="pagingButtons.isNextBtnEnabled" [disabled]="!pagingButtons.isPrevious  || !isDataLoaded">
            <img src="assets/images/chevron-left.svg">
          </button>
          <button (click)="nextFeed()" *ngIf="pagingButtons.isPreviousbtnEnabled" [disabled]="!pagingButtons.isNext  || !isDataLoaded">
            <img src="assets/images/chevron-right.svg">
          </button>
          <button (click)="closeFeedDetailPanel()">
            <img src="assets/images/close.svg">
          </button>
        </div>
      </div>
    </div>
    <div class="ltms-feed-detail-body" *ngIf="isFeedLoaded && isFeedDataAvailable">
      <div class="ltms-feed-detail-response-panel" *ngIf="activeTab.key == 'response'">
        <app-response-panel [feedData]="feedData" [brandDetails]="brandDetails" [feedId]="feedId"></app-response-panel>
      </div>
      <div class="ltms-feed-detail-tab-panel" *ngIf="activeTab.key == 'information'">
        <app-information-panel [brandDetails]="brandDetails" [feedData]="feedData" [feedId]="feedId"></app-information-panel>
      </div>
      <div class="ltms-feed-detail-tab-panel" *ngIf="activeTab.key == 'chat'">
        <app-chat-panel [feedData]="feedData" [brandDetails]="brandDetails" [customerDetails]="{}" [feedId]="feedId" [replyBackAllowed]="replyBackAllowed"></app-chat-panel>
      </div>
      <div class="ltms-feed-detail-tab-panel" *ngIf="activeTab.key == 'history'">
        <app-history-panel [feedId]="feedId" [brandDetails]="brandDetails"></app-history-panel>
      </div>
      <div class="ltms-feed-detail-tab-panel" *ngIf="activeTab.key === 'relationshipView' && !isAccount">
        <app-relationship-view-panel [feedData]="feedData"></app-relationship-view-panel>
      </div>
    </div>
    <div class="feed-details-loader" *ngIf="!isFeedLoaded">
      <app-ltms-loader></app-ltms-loader>
    </div>
    <div class="feed-details-loader" *ngIf="isFeedLoaded && !isFeedDataAvailable">
      <app-ltms-error [code]="error_code"></app-ltms-error>
    </div>
  </div>
</div>
